<template>
  <router-view />
</template>

<style lang="scss" src="./assets/css/main.scss"></style>
